import { Typography } from "@maxhub/max-ui"

export const TypographyActionExample = {
    title: 'Typography.Action',
    defaultPlatform: 'ios',
    defaultZoom: 100,

    controls: [
        {
            name: 'children',
            label: 'children',
            type: 'text',
            tsType: 'string',
            default: 'Hello world',
        },
        {
            name: 'asChild',
            label: 'asChild',
            type: 'static',
            tsType: 'boolean',
            value: '-',
        },
        {
            name: 'variant',
            label: 'variant',
            type: 'enum',
            tsType: ['"small"', '"medium"', '"large"', '"xsmall"', '"custom"'],
            default: 'large',
            options: ['small', 'medium', 'large', 'xsmall', 'custom'],
        },
    ],

    Preview({ props }){
        const actionProps = {
            ...(props.asChild ? { asChild: props.asChild } : {}),
            ...(props.variant ? { variant: props.variant } : {}),
        }

        return (
            <Typography.Action {...actionProps}>
                {props.children}
            </Typography.Action>
        )
    },

    getCode(props){
        const asChildCode = props.asChild ? '\n  asChild' : ''

        return `<Typography.Action${props.variant !== 'large' ? `\n  variant="${props.variant}"` : ''}${asChildCode}>
  ${props.children}
</Typography.Action>`
    }

}